import { swap } from './swap';

export function shuffle<T>(array: T[]): T[] {
  if (!Array.isArray(array)) {
    return [];
  }

  if (array.length <= 1) {
    return array;
  }

  const copy = [...array];

  for (let i = copy.length; i > 0; i--) {
    const guess = Math.floor(Math.random() * i);
    swap(copy, i - 1, guess);
  }

  return copy;
}
